import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import {
  Container, Typography, Button, Box, Grid, Paper, Switch, FormControlLabel, Chip,
  Alert,
  CircularProgress,

  Divider,

  Dialog,
  Tab,
  Tabs,
  Tooltip
} from "@mui/material";
import OpenTransactionStatus from "./components/CashRegisterDemo/OpenTransactionStatus";

import de from 'javascript-time-ago/locale/de'
import TimeAgo from 'javascript-time-ago';
import ReactTimeAgo from 'react-time-ago';
import {
  Table, TableBody, TableCell, TableRow,
} from "@mui/material";
import VoidText from "./components/CashRegisterDemo/VoidText";

import CashRegisterProducts from "./components/CashRegisterDemo/CashRegisterProducts";
import CashpointClosingButton from "./components/CashRegisterDemo/CashpointClosingButton";
import SplitPaymentHandler from "./components/CashRegisterDemo/SplitPayment";
import RefundSelector from "./components/CashRegisterDemo/RefundSelector";
import { useCookies } from "react-cookie";
import POSDisplayCart from "./components/CashRegisterDemo/POSDisplay";
import PrintReceipt from "./components/CashRegisterDemo/PrintReceipt";


import { useCashRegisterSettings } from "./components/CashRegisterDemo/useCashRegisterSettings";
import Transactions from "./components/CashRegisterDemo/Transactions";
import CashPointClosingList from "./components/CashRegisterDemo/CashPointClosingList";
import PinInput from "./components/CashRegisterDemo/PinInput";

TimeAgo.addDefaultLocale(de);

const STATIC_PRODUCTS = [
  //{ name: "Paket S", price: 3.4, sku: "mps1", vat_definition_export_id: 1 },
];

const KASSE_ENDPOINT = 'https://fkcrenezvf.execute-api.eu-central-1.amazonaws.com/Prod';



export default function CashRegisterDemo() {

  const { aclPermissions, crsClientId, crsStatus, login, logout, updatePin, staffName } = useCashRegisterSettings();
  console.log({ aclPermissions })
  if (crsStatus === "LOGGEDOUT") return <Paper sx={{ p: 2 }}><PinInput name={staffName} onSubmit={login} updatePin={updatePin} /></Paper>
  if (crsStatus === "PENDING") return <CircularProgress />;
  if (crsStatus === "SETUP") return <Box>Kasse muss zuerst konfiguriert werden</Box>;

  return (<CashRegisterApp aclPermissions={aclPermissions} crsClientId={crsClientId} crsStatus={crsStatus} logout={logout} initView="FULL" />)
}


function CashRegisterPrefilled({ cart, onSuccess }) {

  const { aclPermissions, crsClientId, crsStatus, login, logout, updatePin, staffName } = useCashRegisterSettings();

  if (crsStatus === "LOGGEDOUT") return <PinInput name={staffName} onSubmit={login} updatePin={updatePin} />
  if (crsStatus === "PENDING") return <CircularProgress />;
  if (crsStatus === "SETUP") return <Box>Kasse konfigurieren</Box>;

  return (<CashRegisterApp aclPermissions={aclPermissions} crsClientId={crsClientId} crsStatus={crsStatus} logout={logout} cart={cart} onSuccess={onSuccess} />)
}

export { CashRegisterPrefilled }


function CashRegisterApp({ aclPermissions, crsClientId, crsStatus, cart: inputCart = [], initView = "BUTTON", onSuccess = () => { }, logout }) {

  const [cookies] = useCookies(['staffName', 'staff', 'crKey'])

  const staffName = cookies.staffName;
  const staffId = cookies.staff;

  const [currentView, setCurrentView] = useState(initView); // BUTTON, FULL, CHECKOUT, TRANSACTIONS, PRODUCTS

  const [transactionId, setTransactionId] = useState(null);
  const [cart, setCart] = useState([]);

  const [receipt, setReceipt] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [stornoMode, setStornoMode] = useState(false);
  const [trainingMode, setTrainingMode] = useState(false);
  const [reversalBase, setReversalBase] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [cancelledQuantities, setCancelledQuantities] = useState({});
  const [vatDefinitions, setVatDefinitions] = useState([]);
  const [allProducts, setAllProducts] = useState([]);

  const [revision, setRevision] = useState(1);


  const [refundSelection, setRefundSelection] = useState({});

  const [lastTxReturnCash, setLastTxReturnCash] = useState(null);
  const [lastTxGivenCash, setLastTxGivenCash] = useState(null);
  const [lstTxId, setLastTxId] = useState(null);

  const [error, setError] = useState()

  // add just below your other useState hooks
  const [isPending, setIsPending] = useState(false); // any request in flight
  const [showTimeoutModal, setShowTimeout] = useState(false); // >1 s timeout
  const lastRequest = useRef(null);                         // remembers last call payload

  const [tseStatus, setTseStatus] = useState(null);


  const authHeaders = {
    headers: {
      Authorization: `Bearer ${cookies.crKey} y 1 z`,
    },
  };

  useEffect(() => {
    if (currentView === 'FULL') {
      setCurrentView('BUTTON')
    }
  }, [currentView])


  const handleRefundSelection = (index, selected) => {
    setRefundSelection(prev => {
      // Wenn bereits ausgewählt, nie zurücknehmen:
      if (prev[index]) {
        return prev;
      }
      // Nur bei einer echten Selektion setzen:
      if (selected) {
        return { ...prev, [index]: true };
      }
      return prev;
    });
  };

  const handleExecuteRefund = () => {

    // erzeuge Liste der ausgewählten Zeilen-Indizes
    const selectedIndices = Object.entries(refundSelection)
      .filter(([_, sel]) => sel)
      .map(([idx]) => parseInt(idx, 10));


    // nur die Zeilen mit den ausgewählten Indizes
    const refundItems = selectedItems
      .filter((_, idx) => selectedIndices.includes(idx))
      .map(item => ({
        name: item.text,
        price: item.item.price_per_unit,
        sku: item.item.number,
        qty: 1,
        storno: true,
        vat_definition_export_id:
          item.business_case?.amounts_per_vat_id?.[0]?.vat_definition_export_id ?? 1,
        purchaser_agency: item.purchaser_agency
      }));


    setCart(refundItems);
    updateTransaction(refundItems);
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${KASSE_ENDPOINT}/products`, authHeaders);
        const dynamic = res.data?.products || [];

        // Combine static and dynamic
        const all = [...STATIC_PRODUCTS, ...dynamic];

        // Group by purchaser_agency and sort by price
        const grouped = groupAndSortProducts(all);

        setAllProducts(grouped);
      } catch (err) {
        console.error("Fehler beim Laden der Produkte:", err);
      }
    };

    fetchProducts();
  }, []);


  const groupAndSortProducts = (products) => {
    const grouped = {};

    for (const p of products) {
      const key = p.purchaser_agency || "__none__";
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(p);
    }

    return Object.entries(grouped).flatMap(([_, list]) =>
      list.sort((a, b) => a.price - b.price)
    );
  };


  /**
   * Sends an axios POST to /transactions **with**
   *  – automatic button-locking (isPending)  
   *  – 1 s timeout -> modal shown  
   *  – retry remembers the last payload
   */
  const txRequest = async (payload) => {
    lastRequest.current = payload;          // remember for Retry button
    setIsPending(true);

    // after 1 000 ms, show modal (but don’t abort request)
    const timeoutId = setTimeout(() => setShowTimeout(true), 1000);

    try {
      const res = await axios.post(
        KASSE_ENDPOINT + "/transactions",
        { ...payload, cashier_name: staffName, cashier_id: staffId },
        authHeaders
      );
      clearTimeout(timeoutId);
      setShowTimeout(false);
      return res;
    } finally {
      setIsPending(false);
    }
  };


  const getTotal = (items) => items.reduce((sum, p) => sum + p.qty * (p.storno ? -p.price : p.price), 0).toFixed(2);
  const getVatSummary = (items) => {
    const summary = {};

    items.forEach(p => {
      const qty = p.qty;
      const price = p.price * (p.storno ? -1 : 1);
      const amount = qty * price;
      const vatId = p.vat_definition_export_id;
      const vatPct = getVatPercentage(vatId);

      if (!summary[vatId]) {
        summary[vatId] = { amount: 0, percentage: vatPct };
      }
      summary[vatId].amount += amount;
    });

    return summary;
  };


  const buildSchema = (items, payments, isAbort) => {

    if (cart.some(p => !vatDefinitions.find(def => def.vat_definition_export_id === p.vat_definition_export_id))) {
      alert("Ein Produkt hat eine ungültige oder nicht geladene VAT-Definition.");
      return;
    }


    const vatSummary = getVatSummary(items);

    const amounts_per_vat_rate = Object.entries(vatSummary).map(([id, { amount, percentage }]) => ({
      vat_rate: String(percentage),
      vat_definition_export_id: parseInt(id),
      amount: amount.toFixed(2)
    }));

    const amounts_per_payment_type = payments?.map(p => {
      const isRefund = cart.every(i => i.storno); // Nur echter Full-Storno → negatives Vorzeichen

      return {
        payment_type: p.method === "CASH" ? "CASH" : p.method === "OTHER" ? "OTHER" : "NON_CASH",
        name: p.method,
        amount: (isRefund ? -p.amount : p.amount).toFixed(2),
        currency_code: "EUR",
        ...(p.method === "CASH" && p.givenCash != null && !isRefund
          ? { change: (p.givenCash - p.amount).toFixed(2) }
          : {}),
        ...(p.foreign_amount && p.foreign_currency && {
          foreign_amount: p.foreign_amount.toFixed(2),
          foreign_currency: p.foreign_currency
        })
      };
    });


    return {
      standard_v1: {
        receipt: {
          receipt_type: trainingMode ? "TRAINING" : isAbort ? 'CANCELLATION' : "RECEIPT",
          amounts_per_vat_rate,
          amounts_per_payment_type: amounts_per_payment_type,

          items: items.map((p, index) => {
            const itemTotal = (p.qty * p.price) * (p.storno ? -1 : 1);
            return {
              lineitem_export_id: `${index + 1}`,
              business_case: {
                type: "Umsatz",
                name: p.name,
                amounts_per_vat_id: [{
                  vat_definition_export_id: p.vat_definition_export_id,
                  vat_rate: String(getVatPercentage(p.vat_definition_export_id)),
                  amount: itemTotal.toFixed(2)
                }]
              },
              in_house: true,
              storno: p.storno || false,
              text: p.name,
              ...(p.purchaser_agency ? { purchaser_agency: p.purchaser_agency } : {}),
              item: {
                number: p.sku,
                quantity: p.qty,
                quantity_factor: 1,
                quantity_measure: "STK",
                group_id: "default",
                group_name: "Allgemein",
                price_per_unit: p.price
              }
            };
          })
        }
      }
    };
  };



  const addProduct = (product) => {
    if (!transactionId) return;

    const sku = product.sku;

    // Offene Transaktion, Storno aktiv, kein reversalBase
    if (stornoMode && !reversalBase) {
      const alreadyAddedQty = cart
        .filter(p => p.sku === sku && !p.storno)
        .reduce((sum, p) => sum + p.qty, 0);

      const alreadyStornoQty = cart
        .filter(p => p.sku === sku && p.storno)
        .reduce((sum, p) => sum + p.qty, 0);

      const stillAllowed = alreadyAddedQty - alreadyStornoQty;
      if (stillAllowed <= 0) {
        alert("Nur bereits erfasste Produkte können storniert werden.");
        return;
      }
    }

    // Storno einer abgeschlossenen Transaktion
    if (stornoMode && reversalBase) {
      const originalItem = selectedItems.find(i => i.item.number === sku);
      const maxQty = originalItem?.item?.quantity || 0;
      const alreadyCancelled = cancelledQuantities[sku] || 0;
      const stillAllowed = maxQty - alreadyCancelled;
      if (stillAllowed <= 0) return;
    }

    // Neuer Eintrag (nicht ersetzen!)
    const newEntry = {
      ...product,
      qty: 1,
      storno: stornoMode
    };
    const updatedCart = [...cart, newEntry];
    setCart(updatedCart);
    updateTransaction(updatedCart);

    if (stornoMode && reversalBase) {
      const newQty = (cancelledQuantities[sku] || 0) + 1;
      setCancelledQuantities(prev => ({ ...prev, [sku]: newQty }));
    }
  };



  const startTransaction = async () => {
    const txId = uuidv4();

    setReceipt(null);
    setCart(inputCart || []);
    setReversalBase(null);
    setSelectedItems([]);
    setCancelledQuantities({});

    setLastTxReturnCash();
    setLastTxGivenCash();
    setLastTxId(null);

    try {
      const res = await txRequest({
        action: "start",
        client_id: crsClientId,
        transaction_id: txId,
        tss_id: crsClientId,
        revision: 1
      }, authHeaders);

      // if you disabled Axios’ default validateStatus, check manually:
      if (res.status < 200 || res.status >= 300) {
        throw new Error(`Request failed with status ${res.status}`);
      }

      setRevision(2);        // success path
      setTransactionId(txId);
      setError();

      if (res.data?.sign_response == null) {
        setTseStatus(false);
      } else {
        setTseStatus(true);
      }


    } catch (err) {
      // Axios puts the server response on err.response (if any)
      const message =
        err.response?.data?.message ??
        err.message ??
        "Unknown error while starting transaction";
      setError(message);
    }




  };

  const cancelTransaction = async () => {

    const schema = buildSchema([], [], true);

    const res = await txRequest({
      action: "cancel",
      client_id: crsClientId,
      transaction_id: transactionId,
      tss_id: crsClientId,
      training_mode: trainingMode,
      schema,
      revision
    }, authHeaders);
    setRevision(revision + 1);
    setTransactionId(null);
    setCart([]);
    setReversalBase(null);
    setSelectedItems([]);
    setCancelledQuantities({});
    setStornoMode(false); // ← ADD THIS

    if (res.data?.sign_response == null) {
      setTseStatus(false);
    } else {
      setTseStatus(true);
    }

    setCurrentView('BUTTON')

  };

  const updateTransaction = async (customCart = cart) => {
    if (!transactionId) return;
    const schema = buildSchema(customCart);
    try {
      const res = await txRequest({
        action: "update",
        client_id: crsClientId,
        transaction_id: transactionId,
        tss_id: crsClientId,
        revision,
        schema
      }, authHeaders);
      setRevision(revision + 1);

      if (res.data?.sign_response == null) {
        setTseStatus(false);
      } else {
        setTseStatus(true);
      }


    } catch (err) {
      console.error("Update failed:", err.response?.data || err);
    }
  };

  const finishTransaction = async ({
    payments = null,

  } = {}) => {
    if (!transactionId) return;



    const schema = buildSchema(cart, payments);

    const result = await txRequest({
      action: "finish",
      client_id: crsClientId,
      transaction_id: transactionId,
      tss_id: crsClientId,
      schema,
      training_mode: trainingMode,
      ...(reversalBase ? { reversal_of: reversalBase } : {}),
      revision
      // keine transaction_details!
    }, authHeaders);

    setRevision(revision + 1);
    setReceipt(result.data);

    const cashPayments = payments?.filter(p => p.method === "CASH");
    setLastTxReturnCash(cashPayments.length ? cashPayments[0].givenCash - cashPayments[0].amount : 0)
    setLastTxGivenCash(cashPayments.length ? cashPayments[0].givenCash : 0)
    setLastTxId(transactionId)

    setTransactionId(null);
    setCart([]);
    setReversalBase(null);
    setSelectedItems([]);
    setCancelledQuantities({});
    setStornoMode(false);

    setTseStatus(!!result.data?.sign_response);

    if (result.data) {
      onSuccess({ status: 'SUCCEEDED', transactionId })
    } else {

    }

  };



  const loadTransactions = async () => {
    const { data } = await axios.get(KASSE_ENDPOINT + `/transactions?client_id=${crsClientId}`, authHeaders);
    setTransactions(data.items);
  };


  const handleDirectAbort = async ({ transactionId }) => {
    const res = await axios.post(
      KASSE_ENDPOINT + "/abort",
      { cashier_name: staffName, cashier_id: staffId, transactionId },
      authHeaders
    );
    loadTransactions();

  }
  const prepareReversal = async (tx) => {

    setCurrentView('CHECKOUT')
    const originalItems = tx.Items || [];

    const cancelled = tx.CancelledItems || {};

    const takenCount = {};
    const adjustedItems = [];

    for (const item of originalItems) {
      const sku = item?.item?.number;
      const qty = parseFloat(item?.item?.quantity || 0);
      const isStorno = item?.storno === true;
      // Neuer Teil: Preis pro Einheit parsen
      const price = parseFloat(item?.item?.price_per_unit || 0);
      const amount = price * qty; // Gesamt-Betrag

      // 1) Keine SKU → überspringen
      // 2) Ungültige Menge → überspringen
      // 3) Storno-Flag → überspringen
      if (!sku || isNaN(qty)) continue;

      // 4) Negative oder Null-Mengen ignorieren
      if (qty <= 0) continue;

      // 5) Gesamt-Betrag ≤ 0 ignorieren


      if (isStorno) {

        adjustedItems.splice(adjustedItems.indexOf(e => e.sku === sku), 1)
      }

      if (isStorno) continue;
      // Verrechnung mit bereits stornierten Einheiten
      const alreadyCancelled = cancelled[sku] || 0;
      takenCount[sku] = takenCount[sku] || 0;

      // Für jede positive, nicht-storno Einheit:
      for (let i = 0; i < qty; i++) {
        // Erst so viele überspringen, wie schon storniert sind
        if (takenCount[sku] < alreadyCancelled) {
          takenCount[sku]++;
          continue;
        }
        // Rest als Einzelstück mit quantity = 1 hinzufügen
        adjustedItems.push({
          ...item,
          item: { ...item.item, quantity: 1 }
        });
        takenCount[sku]++;
      }
    }

    console.log({ adjustedItems, originalItems, cancelled });


    console.log({ adjustedItems, originalItems, cancelled });



    setReversalBase(tx.TransactionId);
    setCart([]);
    setTransactionId(uuidv4());
    setReceipt(null);
    setStornoMode(true);
    setTrainingMode(tx.TrainingMode === true);
    setSelectedItems(adjustedItems);
    setCancelledQuantities({});
    setLastTxId(null);

    const newTxId = uuidv4();
    try {
      const res = await txRequest({
        action: "start",
        client_id: crsClientId,
        transaction_id: newTxId,
        tss_id: crsClientId,
        reversal_of: reversalBase,
        revision: 1
      }, authHeaders);

      if (res.status < 200 || res.status >= 300) {
        throw new Error(`Request failed with status ${res.status}`);
      }

      // local revision always "next number the backend will expect"
      setTransactionId(newTxId);
      setRevision(2);
    } catch (err) {
      const message =
        err.response?.data?.message ??
        err.message ??
        "Unbekannter Fehler beim Start des Storno-Vorgangs";
      // rollback UI so the cashier can try again
      setStornoMode(false);
      setReversalBase(null);
      setError(message);
    }
  };

  useEffect(() => {
    loadTransactions();
    fetchVatDefinitions(); // ← NEW
  }, [crsClientId]);

  const fetchVatDefinitions = async () => {
    try {
      const res = await axios.get(`${KASSE_ENDPOINT}/vat_definitions?order_by=time_creation&order=asc&limit=100&offset=0`, authHeaders);
      setVatDefinitions(res.data?.data || []);
    } catch (err) {
      console.error("Fehler beim Laden der VAT-Definitionen:", err);
    }
  };

  const getVatPercentage = (vatId) => {
    const match = vatDefinitions.find(def => def.vat_definition_export_id === vatId);
    return match?.percentage; // fallback if missing
  };

  const loadOpenTransaction = async (tx) => {

    try {
      const { data } = await axios.get(`${KASSE_ENDPOINT}/transactions/${tx.TransactionId}`, authHeaders);

      if (data.State !== "ACTIVE") {
        alert("Diese Transaktion wurde bereits abgeschlossen und kann nicht mehr geladen werden.");
        return;
      }

      setTransactionId(data.TransactionId);
      setCart((data.Items || []).map(item => ({
        name: item.text,
        price: item.item.price_per_unit,
        sku: item.item.number,
        qty: item.item.quantity,
        storno: item.storno || false,
        vat_definition_export_id: item.business_case?.amounts_per_vat_id?.[0]?.vat_definition_export_id ?? 1,
        purchaser_agency: item.purchaser_agency
      })));
      setRevision(data.Revision + 1)
      setReceipt(null);
      setStornoMode(false);
      setTrainingMode(data.TrainingMode === true);
      setReversalBase(null);
      setSelectedItems([]);
      setCancelledQuantities({});
    } catch (err) {
      console.error("Fehler beim Laden der Transaktion:", err);
      alert("Fehler beim Laden der Transaktion.");
    }
  };

  return (

    <>

      <Dialog open={
        (currentView === 'BUTTON' && initView === 'FULL') || // Neuer Vorgang
        (currentView === 'CHECKOUT' && !!lstTxId && initView !== 'BUTTON') // Vorgang abgeschloßen + Neuer Vorgang
      } fullScreen sx={{ p: 4 }} >
        <Container>
          <CashRegisterNavigation currentView={currentView} setCurrentView={setCurrentView} aclPermissions={aclPermissions} logout={logout} />
          <Typography variant="h4" gutterBottom>Kasse</Typography>
          {!!crsClientId &&
            <Box sx={{ pb: 2 }}>
              <OpenTransactionStatus onAbort={handleDirectAbort} onLoad={(v) => { setCurrentView('CHECKOUT'); loadOpenTransaction(v); }} clientId={crsClientId} />
            </Box>
          }
          {!transactionId && (
            <VoidText text={trainingMode && "TRAINING MODE"}>
              <Box sx={{ p: 4 }}>


                <Box sx={{ display: 'flex', justifyContent: 'space-between', pb: 2 }}>
                  <Button variant="contained" color="success" size="large" onClick={() => { setCurrentView('CHECKOUT'); startTransaction(); }}>
                    Kassen-Vorgang starten
                  </Button>
                  <FormControlLabel
                    control={<Switch checked={trainingMode} onChange={() => setTrainingMode(!trainingMode)} disabled={!!transactionId} />}
                    label="Trainingsmodus"
                  />
                </Box>
                {trainingMode && <Chip label="TRAINING MODUS AKTIVIERT" color="warning" />}



                <Divider sx={{ mb: 2 }} />

                <Box mb={2} display={"flex"} gap={2}>
                  {receipt?.ereceipt?.assets?.pdf_link && (
                    <PrintReceipt pdfUrl={receipt?.ereceipt?.assets?.pdf_link} />

                  )}
                  <POSDisplayCart cart={cart} vatDefinitions={vatDefinitions} returnCash={lastTxReturnCash} receipt={receipt || {}} />
                  {receipt?.ereceipt?.public_link?.href && (
                    <Button size="small" variant="outlined" color="primary" href={receipt.ereceipt.public_link.href} target="_blank">
                      Bon anzeigen
                    </Button>
                  )}
                </Box>

                {!!lastTxReturnCash && <DisplayReturnCash lastTxReturnCash={lastTxReturnCash} lastTxGivenCash={lastTxGivenCash} />}

                {trainingMode && <Alert severity="error">ACHTUNG Trainings-Modus aktiviert! Es werden keine Buchungen vorgenommen!</Alert>}


              </Box>

            </VoidText>
          )}
        </Container>
      </Dialog>




      {currentView === 'BUTTON' && !transactionId && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button variant="contained" color="success" size="large" onClick={() => { setCurrentView('CHECKOUT'); startTransaction(); }}>
            Kassen-Vorgang starten
          </Button>
        </Box>
      )}

      {currentView === 'CHECKOUT' && !!lstTxId && initView === 'BUTTON' && (
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Box mb={2} display={"flex"} gap={2}>
            {receipt?.ereceipt?.assets?.pdf_link && (
              <PrintReceipt pdfUrl={receipt?.ereceipt?.assets?.pdf_link} />

            )}
            <POSDisplayCart cart={cart} vatDefinitions={vatDefinitions} returnCash={lastTxReturnCash} receipt={receipt || {}} />
            {receipt?.ereceipt?.public_link?.href && (
              <Button size="small" variant="outlined" color="primary" href={receipt.ereceipt.public_link.href} target="_blank">
                Bon anzeigen
              </Button>
            )}
          </Box>

          {!!lastTxReturnCash && <DisplayReturnCash lastTxReturnCash={lastTxReturnCash} lastTxGivenCash={lastTxGivenCash} />}

          {trainingMode && <Alert severity="error">ACHTUNG Trainings-Modus aktiviert! Es werden keine Buchungen vorgenommen!</Alert>}
        </Paper>
      )}



      <Dialog open={currentView === 'CHECKOUT' && !!lstTxId && initView !== 'BUTTON'} fullScreen sx={{ p: 4 }} >
        <Box>
          <CashRegisterNavigation currentView={currentView} setCurrentView={setCurrentView} aclPermissions={aclPermissions} logout={logout} />
          <VoidText text={trainingMode && "TRAINING MODE"}>
            <Box sx={{ p: 4 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>

                <Button color="success" variant="contained" size="large" onClick={startTransaction} sx={{ mb: 2 }}>
                  Neuen Kassen-Vorgang starten
                </Button>

                <FormControlLabel
                  control={<Switch checked={trainingMode} onChange={() => setTrainingMode(!trainingMode)} disabled={!!transactionId} />}
                  label="Trainingsmodus"
                />

              </Box>
              <Box mb={2} display={"flex"} gap={2}>
                {receipt?.ereceipt?.assets?.pdf_link && (
                  <PrintReceipt pdfUrl={receipt?.ereceipt?.assets?.pdf_link} />

                )}
                <POSDisplayCart cart={cart} vatDefinitions={vatDefinitions} returnCash={lastTxReturnCash} receipt={receipt || {}} />
                {receipt?.ereceipt?.public_link?.href && (
                  <Button size="small" variant="outlined" color="primary" href={receipt.ereceipt.public_link.href} target="_blank">
                    Bon anzeigen
                  </Button>
                )}

              </Box>

              {!!lastTxReturnCash && <DisplayReturnCash lastTxReturnCash={lastTxReturnCash} lastTxGivenCash={lastTxGivenCash} />}

              {trainingMode && <Alert severity="error">ACHTUNG Trainings-Modus aktiviert! Es werden keine Buchungen vorgenommen!</Alert>}
            </Box>
          </VoidText>
        </Box>
      </Dialog>




      <Dialog open={currentView === 'CHECKOUT' && !lstTxId} fullScreen sx={{ p: 4 }} >
        <Box>
          <VoidText text={trainingMode && "TRAINING MODE"}>
            <Box sx={{ p: 4 }}>
              {!!crsClientId && <Box sx={{ pb: 2 }}>
                {tseStatus === false && <Alert severity="error" sx={{ my: 2 }}>
                  <b>TSE AUSFALL</b> - Kasse weiterhin benutzen, aber sofort technischen Support informieren!
                </Alert>}

              </Box>
              }

              {!!transactionId && (
                <>
                  {/* Produktbuttons */}
                  <Grid container spacing={2}>
                    <Grid item xs={7}>


                      {/* Warenkorb */}
                      <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                        <Typography variant="h6">Buchungspositionen</Typography>
                        {reversalBase && (<Chip label="Rückerstattung" color="error" />)}
                        {stornoMode && !reversalBase && <Chip label="STORNO" color="error" />}
                        <Table>
                          <TableBody>


                            {cart.map((p, i) => (
                              <TableRow sx={{ '& td': { color: p.storno ? 'error.main' : 'text.primary' } }} key={i}>
                                <TableCell>{p.storno ? '-' : ''}{p.qty}×</TableCell>
                                <TableCell>{p.name}</TableCell>
                                <TableCell>{getVatPercentage(p.vat_definition_export_id)}%</TableCell>
                                <TableCell sx={{ textAlign: 'right' }}>{new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(p.storno ? p.qty * p.price * -1 : p.qty * p.price)}</TableCell>
                              </TableRow>
                            ))}
                            {cart.length === 0 &&
                              <TableRow>
                                <TableCell colSpan={4}><Alert severity="info">Noch keine Produkte ausgewählt!</Alert></TableCell>
                              </TableRow>
                            }
                            <TableRow>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell>Gesamt: </TableCell>
                              <TableCell sx={{ textAlign: 'right', fontSize: '24px' }}><b>{getTotal(cart)} €</b></TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Paper>

                      {/* Bezahlbereich */}
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>


                        {stornoMode && reversalBase && (
                          <Box>
                            <Paper variant="outlined" sx={{ p: 2, my: 2 }}>
                              <Typography variant="h6">Storno-Rückzahlung</Typography>
                              <Typography gutterBottom>Auszuzahlen in Bar: {getTotal(cart)} €</Typography>
                              <Button
                                variant="contained"
                                color="success"
                                size="large"
                                onClick={() => {
                                  const amount = parseFloat(getTotal(cart));
                                  const payments = [
                                    { method: "CASH", amount: -amount, givenCash: -amount }
                                  ];

                                  finishTransaction({ payments });
                                }}
                              >
                                Rückzahlung abschließen
                              </Button>
                            </Paper>
                          </Box>
                        )}
                        {!(stornoMode && reversalBase) && (


                          <SplitPaymentHandler
                            onlyCash={trainingMode}
                            transactionId={transactionId}
                            amount={parseFloat(getTotal(cart))}
                            allowSplit={true}
                            onSuccess={(payments, { givenCash, change }) => {

                              const total = parseFloat(getTotal(cart));

                              const cash = payments.find(p => p.method === "CASH")?.amount || 0;
                              const card = payments.find(p => p.method === "CARD")?.amount || 0;
                              const twint = payments.find(p => p.method === "TWINT")?.amount || 0;

                              finishTransaction({
                                payments,
                                paymentMethod: "SPLIT",
                                given: givenCash,
                                change,
                                isSplit: true,
                                cash,
                                card,
                                twint,
                              });
                            }}
                          />

                        )}
                      </Box>

                    </Grid>
                    <Grid item xs={5}>

                      <Box sx={{ pb: 4 }}>

                        <Typography>POS Display</Typography>
                        <Divider sx={{ mt: 1, mb: 2 }} />
                        <POSDisplayCart cart={cart} vatDefinitions={vatDefinitions} returnCash={lastTxReturnCash} receipt={receipt || {}} />
                      </Box>

                      {!(stornoMode && reversalBase) && <>
                        <Typography>Produkte hinzufügen:</Typography>
                        {allProducts.reduce((p, v) => {
                          const other = p.filter(e => e?.purchaser_agency !== v?.purchaser_agency)
                          const match = p.filter(e => e?.purchaser_agency === v?.purchaser_agency)

                          const temp = (match.length === 0)
                            ? {
                              purchaser_agency: v.purchaser_agency,
                              products: []
                            }
                            : match[0]

                          temp.products.push(v)

                          return [...other, temp]
                        }, []).map((g, ii) => (
                          <Box key={ii}>
                            <Divider sx={{ mt: 1, mb: 2 }} />
                            <Grid container spacing={2} mb={2}>
                              {
                                g.products.map((p, i) => (


                                  <Grid item xs={4} key={i}>

                                    <Button
                                      fullWidth
                                      variant="outlined"
                                      onClick={() => addProduct(p)}
                                      color={stornoMode ? "error" : "primary"}
                                      disabled={isPending}
                                    >
                                      <Box>
                                        <Box>{p.name}</Box>
                                        <Box sx={{ fontSize: '12px', color: 'black' }}> {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(stornoMode ? p.price * -1 : p.price)}</Box>
                                      </Box>
                                    </Button>
                                  </Grid>
                                ))
                              }
                            </Grid>
                          </Box>
                        ))}
                      </>}





                      <Typography>Storno</Typography>
                      <Divider sx={{ mt: 1, mb: 2 }} />
                      {stornoMode && reversalBase && (
                        <RefundSelector
                          items={selectedItems}
                          cancelledQuantities={cancelledQuantities}
                          onSelect={(index, selected) => handleRefundSelection(index, selected)}

                          onRefund={handleExecuteRefund}
                          disabled={!transactionId}
                        />
                      )}

                      {!reversalBase && (
                        <Button
                          variant={stornoMode ? "contained" : "outlined"}
                          color="error"
                          onClick={() => setStornoMode(prev => !prev)}
                          disabled={isPending}
                        >
                          {stornoMode ? "Storno-Modus deaktivieren" : "Storno aktivieren"}
                        </Button>
                      )}
                    </Grid>
                  </Grid>

                  {/* Vorgangsaktionen */}
                  <Paper variant="outlined" sx={{ display: 'flex', p: 2 }}>
                    <Button
                      variant="contained"
                      size="large"
                      color="error"
                      onClick={cancelTransaction}
                      disabled={isPending}
                    >Kassenvorgang abbrechen</Button>
                  </Paper>
                </>
              )}
            </Box>

            <Box sx={{ p: 4 }}>



              {error && <Alert severity="error">
                {JSON.stringify(error)}
              </Alert>}

              {tseStatus === false && <Alert severity="error" sx={{ my: 2 }}>
                <b>TSE AUSFALL</b> - Kasse weiterhin benutzen, aber sofort technischen Support informieren!
              </Alert>}

              {trainingMode && <Chip label="TRAINING MODUS AKTIVIERT" color="warning" />}





              {!transactionId && inputCart.length === 0 && (
                <Button color="success" variant="contained" size="large" onClick={startTransaction} sx={{ mb: 2 }}>
                  Neuen Kassen-Vorgang starten
                </Button>
              )}


              {/* Bonanzeige */}

              {trainingMode && <Alert severity="error">ACHTUNG Trainings-Modus aktiviert! Es werden keine Buchungen vorgenommen!</Alert>}

              {receipt?.remaining_reversal_amount && (
                <Typography color="warning.main" sx={{ mb: 2 }}>
                  Verbleibender Storno-Betrag: {receipt.remaining_reversal_amount} €
                </Typography>
              )}
            </Box>
          </VoidText>




        </Box>
      </Dialog>
      <Dialog open={currentView === 'TRANSACTIONS'} fullScreen sx={{ p: 4 }} >
        <Container>
          <CashRegisterNavigation currentView={currentView} setCurrentView={setCurrentView} aclPermissions={aclPermissions} logout={logout} />
          <Typography variant="h4" gutterBottom>Transaktionen</Typography>
          <Transactions crsClientId={crsClientId} prepareReversal={prepareReversal} />
        </Container>
      </Dialog>
      <Dialog open={currentView === 'PRODUCTS'} fullScreen sx={{ p: 4 }} >
        <Container>
          <CashRegisterNavigation currentView={currentView} setCurrentView={setCurrentView} aclPermissions={aclPermissions} logout={logout} />
          <Typography variant="h4" gutterBottom>Produkte</Typography>
          <CashRegisterProducts />
        </Container>
      </Dialog>
      <Dialog open={currentView === 'CPC'} fullScreen sx={{ p: 4 }} >
        <Container>
          <CashRegisterNavigation currentView={currentView} setCurrentView={setCurrentView} aclPermissions={aclPermissions} logout={logout} />
          <Typography variant="h4" gutterBottom>Tagesabschluss</Typography>
          <CashpointClosingButton clientId={crsClientId}>XXX</CashpointClosingButton>
          <Divider sx={{ my: 2 }} />
          <Typography variant="h4" gutterBottom>Z-Berichte Liste</Typography>
          <CashPointClosingList clientId={crsClientId} />
        </Container>
      </Dialog>
    </>
  );
}


const CashRegisterNavigation = ({ currentView, setCurrentView, aclPermissions, logout }) => {

  let views = [{ name: 'CLOSE', label: '< Logout', callback: logout }];

  if (aclPermissions.reg) {
    views.push({ name: 'BUTTON', label: 'Kassenmodus' });
  }
  if (aclPermissions.cpc) {
    views.push({ name: 'CPC', label: 'Z-Bericht / Export' });
    views.push({ name: 'PRODUCTS', label: 'Produkte' });
  }
  if (aclPermissions.refund) {
    views.push({ name: 'TRANSACTIONS', label: 'Transaktionen' });
  }
  if (aclPermissions.stat) {

  }



  const tempCurrentView = currentView === 'CHECKOUT' ? 'BUTTON' : currentView;

  return (

    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs value={tempCurrentView} onChange={(evt, v) => { setCurrentView(v) }} >
        {views.map((e, i) => {
          if (!!e.callback) {
            return <Tab key={i} label={!(tempCurrentView === "FULL" && tempCurrentView === e.name) ? e.label : 'Home'} value={e.name} onClick={logout} />
          }
          return <Tab key={i} label={!(tempCurrentView === "FULL" && tempCurrentView === e.name) ? e.label : 'Home'} value={e.name} />
        })}
      </Tabs>
    </Box>
  );
};



const DisplayReturnCash = ({ lastTxReturnCash, lastTxGivenCash }) => {

  return (
    <Paper sx={{ p: 1 }} variant="outlined">
      <Typography>
        Gegeben: {formatEuro(lastTxGivenCash)}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography variant="body">
        Rückgeld: {formatEuro(lastTxReturnCash)}
      </Typography>
      {false &&
        <Tooltip
          title={
            <ul style={{ listStyle: 'none', padding: 16, color: 'black', backgroundColor: 'white' }}>
              {makeChange(lastTxReturnCash).map((e, i) => (
                <Box
                  component="li"
                  key={i}
                  display="flex"
                  alignItems="center"
                  gap={1}
                  mb={1}
                  position="relative"
                >
                  <strong>{e.c}×</strong>
                  <Box
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: 'solid 3px',
                      borderRadius: e.t === 'coin' ? '50%' : '6px',
                      height: '50px',
                      width: e.t === 'coin' ? '50px' : '100px',
                      backgroundColor: e.t === 'coin' ? '#f0f0f0' : '#e0ffe0',
                      fontWeight: 'bold',
                      fontSize: '1rem',
                      textAlign: 'center',
                      lineHeight: 1,
                      flexDirection: 'column'
                    }}
                  >
                    <span>{e.l1}</span>
                    <small>{e.l2}</small>
                    {e.c > 1 && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: -8,
                          right: -8,
                          backgroundColor: 'red',
                          color: 'white',
                          borderRadius: '50%',
                          width: 20,
                          height: 20,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '0.75rem',
                          fontWeight: 'bold',
                          border: '2px solid white',
                          zIndex: 1
                        }}
                      >
                        {e.c}
                      </Box>
                    )}
                  </Box>
                </Box>
              ))}
            </ul>
          }
        >

          <Typography variant="body">
            Rückgeld: {formatEuro(lastTxReturnCash)}
          </Typography>
        </Tooltip>
      }


    </Paper>
  );
};



const formatEuro = (v) => {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(v)
}

function makeChange(euroAmount) {
  const denominations = [
    { v: 500, t: 'bill', l1: '500', l2: 'Euro' },
    { v: 200, t: 'bill', l1: '200', l2: 'Euro' },
    { v: 100, t: 'bill', l1: '100', l2: 'Euro' },
    { v: 50, t: 'bill', l1: '50', l2: 'Euro' },
    { v: 20, t: 'bill', l1: '20', l2: 'Euro' },
    { v: 10, t: 'bill', l1: '10', l2: 'Euro' },
    { v: 5, t: 'bill', l1: '5', l2: 'Euro' },
    { v: 2, t: 'coin', l1: '2', l2: 'Euro' },
    { v: 1, t: 'coin', l1: '1', l2: 'Euro' },
    { v: 0.5, t: 'coin', l1: '50', l2: 'Cent' },
    { v: 0.2, t: 'coin', l1: '20', l2: 'Cent' },
    { v: 0.1, t: 'coin', l1: '10', l2: 'Cent' },
    { v: 0.05, t: 'coin', l1: '5', l2: 'Cent' },
    { v: 0.02, t: 'coin', l1: '2', l2: 'Cent' },
    { v: 0.01, t: 'coin', l1: '1', l2: 'Cent' }
  ];

  let remaining = Math.round(euroAmount * 100);
  const result = [];

  for (const denom of denominations) {
    const denomCents = Math.round(denom.v * 100);
    const count = Math.floor(remaining / denomCents);
    if (count > 0) {
      result.push({
        v: denom.v,
        t: denom.t,
        c: count,
        l1: denom.l1,
        l2: denom.l2
      });
      remaining -= count * denomCents;
    }
  }

  return result;
}
